// import React, { useEffect, useState } from "react";
import CBrace from "../FakeTags/Brace/CBrace";
import OBrace from "../FakeTags/Brace/OBrace";
import styles from "./Skills.module.css";
import SphereAnimate from "./SphereAnimate";

function Skills() {
  return (
    <div className={styles.container} id="skills">
      <div className={styles.main}>
        <div className={styles.left}>
          <h1 className={styles.head}>
            Skills & <br />
            Experience
          </h1>
          <OBrace />
          {/* <p className={styles.skillDescription}>
            Nostrud ea anim cupidatat proident ipsum in aliquip voluptate Lorem
            tempor dolore in veniam incididunt. Mollit id aute pariatur veniam
            ipsum reprehenderit incididunt excepteur nisi consequat excepteur
            veniam cudo ipsum proident irure ad tempor culpa reprehenderit. Nisi
            nisi sunt esse labore pariatur tempor sunt eu qui non adipisicing.
            Irure aliqua velit non cillum aliqua ad tempor. Adipisicing ullamco
            pariatur minim culpa magna velit ipsum eu ipsum eu aliquip veniam.
          </p> */}
          <div className={styles.experienceCard}>
            <div className={styles.company}>
              <div className={styles.companyName}>Saaspect</div>
              {/* <img src={logo} /> */}
            </div>
            <div className={styles.role}>Frontend React Developer</div>
            <div className={styles.interval}>1 Sep 2021 - 30 Nov 2021</div>
            <div className={styles.workDescription}>
              <div>
                <p>-</p>
                <p>
                  Worked on building client side and admin side interface for an
                  ecommerce website.
                </p>
              </div>
              <div>
                <p>-</p>
                <p>Technologies used - React, Bootstrap</p>
              </div>
            </div>
            <div className={styles.letter}>
              <a
                href="https://drive.google.com/file/d/1arsv_IKPOrMCXHAme1yU-c9YNhakA78L/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <span>View Internship Letter&nbsp;</span>
                <span className={styles.arrowAnimate}>&gt;&gt;</span>
              </a>
            </div>
          </div>
          <CBrace />
        </div>
        <div className={styles.right}>
          {/* {changeWidth(window.innerWidth)} */}
          <SphereAnimate rad="250" />
        </div>
      </div>
    </div>
  );
}

export default Skills;
